import { Directive, Input, OnInit } from '@angular/core';
import { TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { SelectedAccountStore } from '@app/core/stores/selected-account-store.service';
import { ACCOUNT_PERMISSION_LEVEL, USER_ROLE_PERMISSION_LEVEL } from '../enum/permissions';

export interface AccountPermissions {
    accountPermission: ACCOUNT_PERMISSION_LEVEL;
    userRolePermission: USER_ROLE_PERMISSION_LEVEL;
}

@Directive({
    selector: '[permissionLevel]',
    standalone: false,
})
export class PermissionsDirective implements OnInit {
    @Input() set permissionLevel(permissions: AccountPermissions) {
        this.permissions = permissions;
    }

    permissions: AccountPermissions;

    constructor(
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private authenticationService: AuthenticationService,
        private selectedAccountStore: SelectedAccountStore
    ) {}

    ngOnInit(): void {
        const hasAccess = this.hasAccountTypePermission() && this.hasUserRolePermission();

        if (hasAccess) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }

    private hasAccountTypePermission() {
        const validations = {
            [ACCOUNT_PERMISSION_LEVEL.ALL]: () => true,
            [ACCOUNT_PERMISSION_LEVEL.SERVICE_ACCOUNT]: () =>
                !!this.authenticationService.user.serviceAccount,
            [ACCOUNT_PERMISSION_LEVEL.CHILD_ACCOUNT]: () =>
                !this.authenticationService.user.serviceAccount,
        };

        return validations[this.permissions.accountPermission]();
    }

    private hasUserRolePermission() {
        const validations = {
            [USER_ROLE_PERMISSION_LEVEL.ALL]: () => true,
            [USER_ROLE_PERMISSION_LEVEL.ADMIN]: () =>
                this.selectedAccountStore.selectedAccount.isAdmin(),
            [USER_ROLE_PERMISSION_LEVEL.USER]: () =>
                !this.selectedAccountStore.selectedAccount.isAdmin(),
        };

        return validations[this.permissions.userRolePermission]();
    }
}
